import { BaseCombo } from "./base_combo.js";
import { onLoad } from "@otto-ec/global-resources/dom";

export class ComboCinema extends BaseCombo {
	constructor(dom) {
		super(dom);
		this.featureName = "ComboCinema";
		this.viewedArticleSlidesBuffer = [];
		this.alreadySeenArticleSlides = [];
		this._initializeIntersectionObserverForVisibility();
	}

	_initializeArticleDoms() {
		this.articleDoms = Array.prototype.slice.call(this.dom.getElementsByClassName("cinema-combo__cinema-item"), 0);
	}

	initCinemaEvents() {
		const TIMEOUT_DELAY_300_MS = 300;
		setTimeout(() => {
			onLoad.subscribe(() => {
				const articlesCinema = this.dom.querySelector("oc-cinema-v1");
				if (!articlesCinema) {
					this._trackLoadedEvent([], 0);
					return;
				}
				if (articlesCinema.visibleItems) {
					const cinemaArticles = this._getCinemaArticlesForVisibleSlides(articlesCinema);
					this._setAlreadySeenArticleSlides(cinemaArticles.map((_, index) => index));
					this._trackLoadedEvent(cinemaArticles, cinemaArticles.length);
				}
			});
		}, TIMEOUT_DELAY_300_MS);
		this._addArticleCinemaScrollHandlers();
	}

	addClickHandlers() {
		const links = this.dom.querySelectorAll("a");
		for (let i = 0; i < links.length; i++) {
			links[i].addEventListener(
				"click",
				window.o_combo.trackHelper.clickHandlerForArticleClickTracking(i, this, this.featureName)
			);
		}
	}

	_addArticleCinemaScrollHandlers() {
		const articlesCinema = this.dom.querySelector("oc-cinema-v1");
		if (!articlesCinema) {
			return;
		}

		articlesCinema.addEventListener("oc-item-visibility-changed", event => {
			const visibleItemsIndices = event.detail.visibleItems.indices;
			this._updateViewedArticleCinemaBufferSlides(visibleItemsIndices);

			if (event.detail.scrollDirection === "right" && !event.detail.stageIsScrolling) {
				window.o_combo.trackHelper.sendScrollRightOrLeftTrackingEvent(
					this,
					this.featureName,
					this.viewedArticleSlidesBuffer,
					"next"
				);
				this._updateAlreadySeenArticleSlides();
				this._resetViewedArticleCinemaBufferSlides();
			} else if (event.detail.scrollDirection === "left" && !event.detail.stageIsScrolling) {
				window.o_combo.trackHelper.sendScrollRightOrLeftTrackingEvent(this, this.featureName, [], "previous");
				this._updateAlreadySeenArticleSlides(visibleItemsIndices);
				this._resetViewedArticleCinemaBufferSlides();
			}
		});
	}

	_updateViewedArticleCinemaBufferSlides(indices) {
		const notInAlreadySeenSlides = indices.filter(index => !this.alreadySeenArticleSlides.includes(index));

		this.viewedArticleSlidesBuffer = Array.from(
			new Set(this.viewedArticleSlidesBuffer.concat(notInAlreadySeenSlides))
		);
	}

	_resetViewedArticleCinemaBufferSlides() {
		this.viewedArticleSlidesBuffer = [];
	}

	_setAlreadySeenArticleSlides(articlesCinema) {
		this.alreadySeenArticleSlides = articlesCinema;
	}

	_updateAlreadySeenArticleSlides() {
		this.alreadySeenArticleSlides = this.alreadySeenArticleSlides.concat(this.viewedArticleSlidesBuffer);
	}

	_trackLoadedEvent(articlesToTrack, articleCountToTrack) {
		window.o_combo.trackHelper.trackViewForCombo(this, articlesToTrack, articleCountToTrack, this.featureName);
	}

	_getCinemaArticlesForVisibleSlides(cinema) {
		return Array.from(cinema.visibleItems)
			.map(item => {
				const articleId = item.dataset["article_id"];
				return this.articles.find(article => article.id === articleId);
			})
			.filter(article => article !== undefined);
	}

	_initializeIntersectionObserverForVisibility() {
		const observerThreshold = 0.3;
		this.observer = new IntersectionObserver(
			(entries, intersectionObserver) => {
				this._intersectionObserverCallback(entries, intersectionObserver);
			},
			{
				threshold: observerThreshold
			}
		);
		onLoad.subscribe(() => {
			this.observer.observe(this.dom);
		});
	}

	_intersectionObserverCallback(entries, intersectionObserver) {
		const articlesCinema = this.dom.querySelector("oc-cinema-v1");
		const entry = entries[0];
		if (entry.isIntersecting) {
			intersectionObserver.disconnect();
			if (!articlesCinema) {
				window.o_combo.trackHelper.trackComboVisibility(this, [], 0, this.featureName);
				return;
			}
			const articles = this._getCinemaArticlesForVisibleSlides(articlesCinema);
			window.o_combo.trackHelper.trackComboVisibility(this, articles, articles.length, this.featureName);
		}
	}
}
